<template>
    <v-container fluid fill-height>
        <v-layout>
            <v-container >
                <v-layout>
                    <v-flex md4 offset-md4>
                        <div class="text-md-center">
                            <div class="display-4 grey--text">404</div>
                            <div class="body-1">Страница не найдена</div>
                            <div class="m-20"></div>
                            <v-btn outline round color="blue" @click="returnUrl">На главную</v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-layout>
    </v-container>
</template>

<script>
  import store from '@/store'
  export default {
    data () {
      return {}
    },
    methods: {
      returnUrl: function () {
        this.$router.push('/')
      }
    },
    mounted: function () {
      store.commit('setPageTitle', '404')
    }
  }
</script>